import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 91CCFF94-D3F6-48B2-B62C-02DC1B6DBC1E
 * name credit-card
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const CreditCardIcon = createSvgIcon(<><path d="M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 11H4V8H20Z" /></>, 'CreditCardIcon');
export default CreditCardIcon